var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSunset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: "24px",
    id: "Layer_1",
    viewBox: "0 0 24 24",
    width: "24px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1,13h3.1C4,12.7,4,12.3,4,12s0-0.7,0.1-1H1c-0.6,0-1,0.4-1,1S0.4,13,1,13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7,7.1c0.2-0.3,0.4-0.5,0.7-0.8s0.5-0.5,0.8-0.7L4.9,3.5c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4L5.7,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,4.1V1c0-0.6-0.4-1-1-1s-1,0.4-1,1v3.1C11.3,4,11.7,4,12,4C12.3,4,13,4,13,4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3,7.1l2.2-2.2c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-2.2,2.2c0.3,0.2,0.5,0.4,0.8,0.7C17.9,6.6,18.3,7.1,18.3,7.1   z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,12c0,0.3,0,1-0.1,1H23c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1l-3.1,0C20,11.3,20,11.7,20,12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8v1c1.7,0,3,1.3,3,3h1C16,9.8,14.2,8,12,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,12c0-3.9-3.1-7-7-7s-7,3.1-7,7c0,0.7,0.1,1.4,0.3,2H0v1h24v-1h-5.3C18.9,13.4,19,12.7,19,12z M16.6,14H7.4   C7.2,13.4,7,12.7,7,12c0-2.8,2.2-5,5-5s5,2.2,5,5C17,12.7,16.8,13.4,16.6,14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,16h-4v3H7l5,5l5-5h-3V16z M14.6,20L12,22.6L9.4,20H10h1v-3h2v3h1H14.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunset);
export default __webpack_public_path__ + "static/media/sunset.f86bb8b3c563696a816b24fe0a8f40e1.svg";
export { ForwardRef as ReactComponent };